/** google sdk select_by values for One Tap, doc: https://developers.google.com/identity/gsi/web/reference/js-reference?hl=zh-tw#select_by */
const ONE_TAP_SELECT_BY_VALUES = new Set(['user', 'fedcm', 'fedcm_auto', 'user_1tap', 'user_2tap', 'itp', 'itp_confirm'])

export function isGoogleOneTapTriggered(selectBy?: string): boolean {
  return !!selectBy && ONE_TAP_SELECT_BY_VALUES.has(selectBy)
}
